// chart
import Bar from '@/components/Charts/Bar';
import ChartCard from '@/components/Charts/ChartCard';
import MiniArea from '@/components/Charts/MiniArea';
import MiniBar from '@/components/Charts/MiniBar';

export { MiniArea, MiniBar, Bar, ChartCard };



// WEBPACK FOOTER //
// ./src/components/index.js